import styled from 'styled-components';
import { CopyButton } from '@perch-labs/shrike';

const inputRadius = props => props.theme.borderRadii.small;

export const CopyComponent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${props => props.theme.colors.background.controls};
  border-bottom: 1px solid ${props => props.theme.colors.background.controls};
  border-left: 1px solid ${props => props.theme.colors.background.controls};
  border-radius: ${props => inputRadius(props)};
  height: 48px;
  padding: 12px 0 12px 16px;

  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const StyledCopyButton = styled(CopyButton)`
  border-radius: ${props => `0 ${inputRadius(props)} ${inputRadius(props)} 0`};
`;
